/** Canonical SEO copy — single source of truth for public marketing pages. */

export const SEO_BASE_URL = "https://tellerwand.com";

export const HOME_PAGE_SEO_TITLE =
  "TellerWand | Family Wealth Management & Personal Finance for India";

/** Keep ≤160 chars so SERP snippets are not truncated. */
export const HOME_PAGE_SEO_DESCRIPTION =
  "Family wealth management for Indian households. Track PPF, EPF, NPS, mutual funds, gold and real estate with shared goals and portfolio views. Start free.";

export const HOME_PAGE_SEO_KEYWORDS =
  "family wealth management India, family finance app, family portfolio tracker, household wealth management, personal finance app India, wealth management software, investment tracker India, PPF calculator, EPF tracker, NPS calculator, mutual fund tracker, family finance tracker, asset management India, retirement planning India, free expense tracker, SIP calculator";

export const FAMILY_WEALTH_SEO_TITLE = "Family Wealth Management Software India | TellerWand";

export const FAMILY_WEALTH_SEO_DESCRIPTION =
  "Manage family wealth in one dashboard — consolidated net worth, member profiles, shared goals, role-based access, family binder, and asset inventory built for Indian households.";

export const FAMILY_WEALTH_SEO_KEYWORDS =
  "family wealth management India, family finance software, family portfolio management, household net worth tracker, family investment tracker, shared financial goals India, family expense management, multi-member finance app, family asset tracking, succession planning finances India";

export const FEATURES_PAGE_SEO_TITLE =
  "Features | Family Wealth Management & Personal Finance | TellerWand";

export const FEATURES_PAGE_SEO_DESCRIPTION =
  "Explore TellerWand features: family wealth management, investment tracking, portfolio analysis, shared goals, expense management, calculators, and bank-grade security for Indian households.";

export const FEATURES_PAGE_SEO_KEYWORDS =
  "family wealth management features, investment tracking India, portfolio analysis, family finance, goal planning, expense management, TellerWand features, personal finance software";

export const SIGNUP_PAGE_SEO_DESCRIPTION =
  "Create a free TellerWand account in minutes. Track family wealth, PPF, EPF, NPS, mutual funds, stocks and expenses — no credit card required.";

export const ABOUT_PAGE_SEO_TITLE =
  "About TellerWand | Family Wealth Management for Indian Households";

export const ABOUT_PAGE_SEO_DESCRIPTION =
  "TellerWand builds family wealth management software for Indian households. Track 12+ asset types, manage member profiles, and see consolidated family portfolio views with enterprise-grade security.";

/** Public routes included in sitemap.xml and prerender build step. */
export const PRERENDER_PUBLIC_ROUTES = [
  "/",
  "/about",
  "/features",
  "/family-wealth-management",
  "/pricing",
  "/faq",
  "/contact-us",
  "/referrals",
  "/calculators",
  "/calculators/ppf",
  "/calculators/sip",
  "/calculators/incometax",
  "/calculators/homeloan",
  "/calculators/retirement",
  "/calculators/insurance",
  "/calculators/emergency",
  "/calculators/pf",
  "/terms",
  "/privacy",
] as const;

export type PrerenderPublicRoute = (typeof PRERENDER_PUBLIC_ROUTES)[number];

export const FAMILY_WEALTH_CAPABILITIES = [
  {
    title: "Consolidated family net worth",
    description:
      "See combined wealth across members with wealth insights, asset maps, and snapshot tracking.",
  },
  {
    title: "Member profiles & role-based access",
    description:
      "Add spouse, children, and dependents with controls over who can view or edit each part of your finances.",
  },
  {
    title: "Shared goals & planning",
    description:
      "Set family goals for education, home, retirement, or custom milestones and track progress together.",
  },
  {
    title: "Family binder & secure vault",
    description:
      "Store documents, notes, asset inventory, and transfer templates in one secure family vault.",
  },
  {
    title: "Life admin in one hub",
    description:
      "Calendar, tasks, preparedness checklists, and succession planning tools for household finances.",
  },
  {
    title: "12+ asset types for India",
    description:
      "Track PPF, EPF, NPS, mutual funds, stocks, gold, real estate, and more per member or household-wide.",
  },
] as const;
